<span
  class="core-ui-file-type-icon"
  [class.core-ui-file-type-icon--sm]="size === 'sm'"
  [class.core-ui-file-type-icon--md]="size === 'md'"
  [class.core-ui-file-type-icon--lg]="size === 'lg'"
  [attr.data-category]="visualCategory"
  role="img"
  [attr.aria-label]="'Tipo de archivo: ' + displayLabel"
>
  <svg
    class="core-ui-file-type-icon__silhouette"
    viewBox="0 0 48 56"
    aria-hidden="true"
    focusable="false"
  >
    <path
      class="core-ui-file-type-icon__sheet"
      data-part="file-silhouette"
      d="M9 1.5h20l10 10v40A2.5 2.5 0 0 1 36.5 54h-27A2.5 2.5 0 0 1 7 51.5V4a2.5 2.5 0 0 1 2-2.5z"
    ></path>
    <path
      class="core-ui-file-type-icon__fold"
      data-part="fold"
      d="M29 1.5v8a2 2 0 0 0 2 2h8"
    ></path>
    <path
      class="core-ui-file-type-icon__glyph"
      [class.core-ui-file-type-icon__glyph--text]="visualCategory === 'text'"
      [attr.data-glyph]="visualCategory"
      [attr.d]="glyphPath"
    ></path>
    <path
      class="core-ui-file-type-icon__custom-accent"
      data-part="custom-accent"
      d="M7.75 15v29"
      [style.stroke]="color"
    ></path>
  </svg>
  <span class="core-ui-file-type-icon__label">{{ displayLabel }}</span>
</span>
